import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-xl text-background-50"></i>
              </div>
              <span className="text-lg font-bold font-heading text-foreground-50">{siteInfo.name}</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              {siteInfo.slogan}。极致视觉体验，超清画质不缓冲流畅观看。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-foreground-50 font-semibold mb-4 text-sm">影视分类</h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    <i className={`${cat.icon} mr-2 text-xs`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-50 font-semibold mb-4 text-sm">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页推荐</Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">最新电影</Link>
              </li>
              <li>
                <Link to="/category/drama" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">热播剧集</Link>
              </li>
              <li>
                <Link to="/category/anime" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">热门动漫</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-50 font-semibold mb-4 text-sm">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line mt-0.5"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line mt-0.5"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} {siteInfo.name} 版权所有 | 本站所有资源均来自互联网，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}